//core
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type AiCopilotSliceState = {
  isOpen: boolean;
  lastErrorCode: string | null;
};

const initialState: AiCopilotSliceState = {
  isOpen: false,
  lastErrorCode: null,
};

const aiCopilotSlice = createSlice({
  name: 'aiCopilot',
  initialState,
  reducers: {
    openAiCopilot(state: AiCopilotSliceState) {
      state.isOpen = true;
    },
    closeAiCopilot(state: AiCopilotSliceState) {
      state.isOpen = false;
    },
    setAiCopilotError(state: AiCopilotSliceState, action: PayloadAction<string | null>) {
      state.lastErrorCode = action.payload;
    },
    clearAiCopilotState() {
      return initialState;
    },
  },
});

export default aiCopilotSlice.reducer;

export const {
  openAiCopilot,
  closeAiCopilot,
  setAiCopilotError,
  clearAiCopilotState,
} = aiCopilotSlice.actions;
